export const STORE_EVENT_PREFIX = 'store:';
export const ANALYTICS_EVENT_TYPE = 'AnalyticsEvent';
export const wrap = (event) => ({
    name: ANALYTICS_EVENT_TYPE,
    params: {
        ...event,
        name: `${STORE_EVENT_PREFIX}${event.name}`,
    },
});
export const unwrap = (event) => {
    return {
        ...event.params,
        name: event.params.name.slice(STORE_EVENT_PREFIX.length, event.params.name.length),
    };
};
//# sourceMappingURL=wrap.js.map